export default (app) => {
  if (!app.settings.background) return;
  const inspectors = new Map();
  const waitingInspectors = new Map();
  chrome.runtime.onConnect.addListener((port) => {
    if (port.name !== "remotor-inspect") return;
    let tabId;
    port.onMessage.addListener((message) => {
      if (message.tabId === undefined) return;
      tabId = message.tabId;
      inspectors.set(tabId, port);
      waitingInspectors.get(tabId)?.(port);
    });
    port.onDisconnect.addListener(() => {
      if (inspectors.get(tabId) === port) inspectors.delete(tabId);
    });
  });
  app.on("start", () => {
    const syncCleanMenu = async () => {
      if (!app.session.user) return;
      const { data } = await app.database.remotorapp.get({ id: "desktop" });
      if (data) await app.storage.setItem({ id: "cleanMenu", value: data.cleanMenu !== false });
    };
    const syncCleanMenuItems = async () => {
      if (!app.session.user) return;
      const { data } = await app.database.menuItem.search({ filter: { $and: [{ enabled: true }] }, sortby: ["sort"] });
      if (data)
        await app.storage.setItem({
          id: "cleanMenuItems",
          value: data.map(({ name, context, action, url, background, event }) => ({
            name,
            context,
            action,
            url,
            background,
            event,
          })),
        });
    };
    app.database.remotorapp.on("update", -1100, ({ ids }) => {
      if (!ids || ids.includes("desktop")) return syncCleanMenu();
    });
    app.database.menuItem.on("update", -1100, syncCleanMenuItems);
    const syncAll = async () => {
      await syncCleanMenu();
      await syncCleanMenuItems();
    };
    app.on("login", syncAll);
    syncAll();
  });
  app.on("extensionMessage", -100, async ({ message, sender }) => {
    if (sender.tab && message?.type === "cleanMenuInspect") {
      let port = inspectors.get(sender.tab.id);
      if (!port) {
        await chrome.tabs.update(sender.tab.id, { active: true });
        await chrome.windows.update(sender.tab.windowId, { focused: true });
        const { error } = await app.connection.emit({ type: "remotorInspect" });
        if (error) return { ok: false, error };
        port =
          inspectors.get(sender.tab.id) ||
          (await new Promise((resolve) => {
            const timer = setTimeout(() => {
              waitingInspectors.delete(sender.tab.id);
              resolve(null);
            }, 10000);
            waitingInspectors.set(sender.tab.id, (port) => {
              clearTimeout(timer);
              waitingInspectors.delete(sender.tab.id);
              resolve(port);
            });
          }));
        if (!port)
          return {
            ok: false,
            error: "Could not open DevTools. Check that the remotor companion is running and has Accessibility access.",
          };
      }
      return new Promise((resolve) => {
        const requestId = app.uuid();
        const onMessage = (response) => {
          if (response.requestId !== requestId) return;
          clearTimeout(timer);
          port.onMessage.removeListener(onMessage);
          resolve(response);
        };
        const timer = setTimeout(() => {
          port.onMessage.removeListener(onMessage);
          resolve({ ok: false, error: "DevTools did not respond. Reopen it and try again." });
        }, 5000);
        port.onMessage.addListener(onMessage);
        port.postMessage({ requestId, frameURL: sender.url });
      });
    }
    if (sender.tab && message?.type === "cleanMenuEvent") {
      const { value: items } = await app.storage.getItem({ id: "cleanMenuItems" });
      if (!items?.some((item) => item.action === "event" && item.event === message.event))
        return { ok: false, error: "Unknown menu event." };
      const { error } = await app.connection.emit({
        type: message.event,
        text: message.text,
        link: message.link,
        image: message.image,
        page: message.page,
      });
      return error ? { ok: false, error } : { ok: true };
    }
    if (!sender.tab || message?.type !== "cleanMenuOpen") return;
    let url;
    try {
      url = new URL(message.url);
    } catch {
      return { ok: false };
    }
    if (!["https:", "http:"].includes(url.protocol)) return { ok: false };
    try {
      await chrome.tabs.create({ url: url.href, active: !message.background, index: sender.tab.index + 1 });
      return { ok: true };
    } catch {
      return { ok: false };
    }
  });
};
